import React, { FC, ReactNode } from "react";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { useAppSelector } from "src/hooks/redux";
import { Sizes } from "src/@types/sizes";
import { ONLY_FOR, OnlyFor } from "./types";
import { Loader } from "../Loader";

interface Props {
  children: ReactNode;
  onlyFor: OnlyFor;
  loaderSize?: Sizes;
  loaderClassName?: string;
  showLoader?: boolean;
}
export const Show: FC<Props> = ({
  children,
  onlyFor,
  loaderSize,
  loaderClassName,
  showLoader = true,
}) => {
  const { isAuthorized, isLoading, currentUser } = useAppSelector(
    selectCurrentUserState
  );

  const isUserAgent = isAuthorized && currentUser.host.role === ONLY_FOR.AGENT;
  const isUserOwner = isAuthorized && currentUser.host.role === ONLY_FOR.OWNER;

  if (isLoading && showLoader)
    return <Loader size={loaderSize} className={loaderClassName} />;

  if (onlyFor === ONLY_FOR.AGENT && isUserAgent) return <>{children}</>;

  if (onlyFor === ONLY_FOR.OWNER && isUserOwner) return <>{children}</>;

  if (isAuthorized && onlyFor === ONLY_FOR.AUTHORIZED) return <>{children}</>;

  return null;
};
